<template>
  <div class="tax-con">
    <reverse-display-item :list="list"></reverse-display-item>
    <div class="infos">
      <p class="text1">请您确认授权浦发银行访问您的税务电子信息，包括但不限于：</p>
      <p class="text2">
        •&nbsp;获取您的纳税人基本信息<br/>
        •&nbsp;查询您的财务报表信息<br/>
        •&nbsp;查询您的纳税信息和申报缴税信息<br/>
        •&nbsp;查询您的税务违法违章信息和稽查案件信息<br/>
      </p>
    </div>
    <Button :text="text" :type="danger" :loading="isLoading" :disabled="isLoading" loadingText="提交中..." :class="isLoading ? 'next-gray' : 'next'" :click="onSubmit" />
  </div>
</template>

<script>
import ReverseDisplayItem from '@/components/ReverseDisplayItem.vue';
import Button from '@/components/Button.vue';
import { Toast } from 'vant';

export default {
  name: 'taxEmpower',
  components: {
    ReverseDisplayItem,
    Button
  },
  data() {
    return {
      list: [
        {label: '企业名称', key: 'corpName'},
        {label: '纳税人识别号', key: 'taxNo'},
        {label: '法人名称', key: 'borrowerName'},
        {label: '法人身份证号', key: 'borrowerId'},
      ],
      text: '确认授权',
      danger: 'danger',
      isLoading: false,
    };
  },
  mounted() {
    this.enterpriseInfo();
  },
  methods: {
    // 反显企业数据 此页面pageId：8
    async enterpriseInfo() {
      try {
        const { data, success, returnMessage } = await this.$api.OtherPage.queryEchoInfo(
          {
            orderId: this.$route.query.orderId,
	          pageId: this.$route.query.pageId
          },
        );
        if (success) {
          this.list.forEach(e => {
            this.$set(e, 'value', data[e.key]);
          });
        } else {
          Toast(returnMessage);
        }
      } catch (e) {
        Toast('接口异常');
      }
    },
    onSubmit() {
      this.$dialog.confirm({
        title: '提示',
        message: '税务数据授权是获取增信，提高授信额度的重要手段。确认已完成？',
        confirmButtonText: '确认',
        cancelButtonText: '取消',
      }).then(() => {
        this.isLoading = true;
        (async () => {
            try {
            const { success, returnMessage } = await this.$api.OtherPage.commitApply(
              {
                orderId: this.$route.query.orderId,
                pageId: this.$route.query.pageId
              },
            );
            if (success) {
              this.$store.dispatch('otherPages/jumpCurrPageServer');
            } else {
              this.isLoading = false;
              Toast(returnMessage);
            }
          } catch (e) {
            this.isLoading = false;
            Toast('接口异常');
          }
        })()
      })
    },
  },
};
</script>
<style scoped>
.tax-con {
  /* width: 94%; */
  /* margin: 0 auto; */
}
.tax-con .title {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  font-size: 16px;
  font-weight: bold;
}
.tax-con .title img {
  width: 35px;
  margin-right: 10px;
}
.tax-con p {
  text-align: left;
  color: #666;
  line-height: 20px;
}
.tax-con .text1 {
  margin: 20px ​0 6px 0;
  font-size: 16px;
  font-weight: bold;
  color: #2F3133;
}
.tax-con .text2 {
  margin-top: 0;
  font-size: 12px;
  color: #767980;
}

.infos {
  padding: 0 16px;
}
.next >>> .van-button {
  box-shadow: 0px 12px 12px -10px #ff6538;
  border: 0;
  margin-top: 5px;
  transition: 0.7s;
}
.next-gray >>> .van-button {
  box-shadow: 0px 12px 12px -10px #7691a3;
  border: 0;
  margin-top: 5px;
  transition: 0.7s;
}
</style>
